import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectBillingDocumentsAggridData } from "selectors";

export const useGetBillingDocumentRowDataByBillingRunOrBusinessId = (
  billingRunId,
  businessId,
) => {
  const billingDocumentRowData = useSelector(selectBillingDocumentsAggridData);

  const rowData = useMemo(() => {
    if (billingRunId) {
      return billingDocumentRowData.filter(
        billingDocumentRow =>
          billingDocumentRow.billingDocument.billingRunId === billingRunId,
      );
    } else if (businessId) {
      return billingDocumentRowData.filter(
        billingDocumentRow => billingDocumentRow.business.id === businessId,
      );
    }
    return billingDocumentRowData;
  }, [billingDocumentRowData, businessId, billingRunId]);

  return rowData;
};
